import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Returns null while loading, 'member' or 'admin' once resolved
export function useUserRole(user) {
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!user) { setRole(null); return; }
    return onSnapshot(doc(db, 'users', user.uid),
      (snap) => {
        setRole(snap.exists() ? (snap.data().role ?? 'member') : 'member');
      },
      (err) => {
        // Fail safe to least-privilege on a read error (e.g. right after sign-out).
        console.error('[useUserRole] snapshot error:', err);
        setRole('member');
      },
    );
  }, [user]);

  return role;
}
